<template>
  <div>
    <h-loading v-if="isAnnouncementLoading" />

    <div v-else>
      <h6 class="text-uppercase grey--text">
        {{  $t('announcement.label.summary.title') }}
      </h6>
      <p class="body-2">
        {{ announcement.title }}
      </p>

      <h6 class="text-uppercase grey--text">
        {{  $t('announcement.label.summary.content') }}
      </h6>
      <v-card class="mb-6" outlined>
        <iframe :srcdoc="announcement.content" width="100%" frameborder="0" />
      </v-card>

      <v-row>
        <v-col class="py-0">
          <h6 class="text-uppercase grey--text">
            {{  $t('announcement.label.summary.send') }}
          </h6>
          <p class="body-2">
            {{ releaseDate }}
          </p>
        </v-col>
        <v-col class="py-0">
          <h6 class="text-uppercase grey--text">
            {{  $t('announcement.label.summary.type') }}
          </h6>
          <p class="body-2">
            {{ $t(`announcement.label.create.announcementTypes.${announcement.type}`) }}
          </p>
        </v-col>
      </v-row>

      <h6 class="text-uppercase grey--text mt-1">
        {{  $t('announcement.label.summary.hosts') }}
      </h6>
      <div v-if="hosts">
        <p v-for="(host, index) in hosts" :key="index" class="body-2 mb-1">
          {{ host.name }}
          <span class="d-block caption grey--text">
            {{ host.username }}
          </span>
        </p>
      </div>
      <p v-else class="body-2 mb-0"> --- </p>

      <h6 class="text-uppercase grey--text mt-4">
        {{  $t('announcement.label.summary.cities') }}
      </h6>
      <div v-if="cities">
        <p v-for="(city, index) in cities" :key="index" class="body-2 mb-1">
          {{ formatCityState(city) }}
        </p>
      </div>
      <p v-else class="body-2"> --- </p>

      <h6 class="text-uppercase grey--text mt-5">
        {{  $t('announcement.label.summary.services') }}
      </h6>
      <div v-if="services">
        <p v-for="(service, index) in services" :key="index" class="body-2 mb-1">
          {{ $t(`appointment.type.${service}`) }}
        </p>
      </div>
      <p v-else class="body-2"> --- </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { catalogDate } from '@/util/catalog'

export default {
  name: 'AnnouncementSummary',

  computed: {
    ...mapGetters(['announcement', 'isAnnouncementLoading']),

    releaseDate() {
      if (!this.announcement.release_date) return this.$t('announcement.label.summary.immediately')
      return catalogDate(this.announcement.release_date)
    },

    hosts() {
      if (!this.announcement?.hosts?.length) return
      return this.announcement?.hosts
    },

    cities() {
      if (!this.announcement?.cities?.length) return
      return this.announcement.cities
    },

    services() {
      if (!this.announcement?.services?.length) return
      return this.announcement.services
    }
  },

  methods: {
    formatCityState(city) {
      const cityName = city.name
      const cityState = city.state.acronym
      return `${cityName}/${cityState}`
    }
  }
}
</script>
